import styled from 'styled-components';

import { ButtonLink } from '~/components/button-link/ButtonLink';

export const ReadMoreButton = styled(ButtonLink)`
  margin-left: 5px;

  &:focus {
    outline: none;
  }
`;
